import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Home from '../../components/main/Home'
import { sendLogin } from '../../actions/userActions'
import { showPopup, showMessage } from '../../actions/uiActions'
import { bindActionCreators } from 'redux';

function HomeContainer(props) {
    let navigate = useNavigate();
    let location = useLocation();

    // trigger on component mount
    useEffect(() => {
        if (props.loggedIn && location.pathname === "/") {
            props.showPopup("loadingPopup", "Welcome to BI Cloud");
    
            // Redirect user if they tried to access a page without being logged in
            let { from } = window.location.state || { from: { pathname: '/welcome'}}
            navigate(from);
        }
    });

    return <Home customerName={props.customerName} loggedIn={props.loggedIn} sendLogin={props.sendLogin} showPopup={props.showPopup} randNumber={props.randNumber} showMessage={props.showMessage} />
}

function mapStateToProps(state) {
    return {
        customerName: state.users.customerName,
        email: state.users.email,
        loggedIn: state.users.loggedIn,
        popupFlag: state.ui.popupFlag,
        randNumber: state.ui.randNumber,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ sendLogin, showPopup, showMessage }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer)